import * as React from "react";
import { Component } from "react";
import { Col, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import LoadingStatus from "src/components/common/LoadingStatus";
import { IBaseState } from "src/interfaces";
import { IElectricityFromGridProps } from "./interfaces";

export default class ElectricityFromGrid extends Component<IElectricityFromGridProps, IBaseState> {
  public constructor(props: IElectricityFromGridProps) {
    super(props);

    this.state = {
      loading: true,
    };

    this.handleGridReadDateChanged = this.handleGridReadDateChanged.bind(this);
    this.handleGridReadingChanged = this.handleGridReadingChanged.bind(this);
    this.handlePriorGridReadDateChanged = this.handlePriorGridReadDateChanged.bind(this);
    this.handlePriorGridReadingChanged = this.handlePriorGridReadingChanged.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset>
          <legend>Electricity from Grid</legend>
          <LoadingStatus width={25} height={25} singular={true} />
        </fieldset>
      );
    }

    const readOnly: boolean = this.props.match.params.priorId === undefined ? false : true;

    const xsLabelWidthL = 6;
    const xsInputWidthL = 6;
    const smLabelWidthL = 6;
    const smInputWidthL = 6;
    const mdLabelWidthL = 6;
    const mdInputWidthL = 6;
    return (
      <fieldset className="fieldset-left">
        <legend>Electricity from Grid</legend>
        <FormGroup bsSize="small" controlId="gridReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Read Date
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.gridReadDate).toISOString().substring(0, 10)}
              onChange={this.handleGridReadDateChanged}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="gridReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.gridReading}
              onChange={this.handleGridReadingChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorGridReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Last Read
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.priorGridReadDate).toISOString().substring(0, 10)}
              readOnly={true}
              tabIndex={-1}
              onChange={this.handlePriorGridReadDateChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorGridReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.priorGridReading}
              readOnly={readOnly}
              tabIndex={readOnly ? -1 : undefined}
              onChange={this.handlePriorGridReadingChanged}
            />
          </Col>
        </FormGroup>
      </fieldset>
    );
  }

  private handleGridReadDateChanged(e: any) {
    this.props.gridReadDateChanged(e);
  }
  private handleGridReadingChanged(e: any) {
    this.props.gridReadingChanged(e);
  }
  private handlePriorGridReadDateChanged(e: any) {
    this.props.priorGridReadDateChanged(e);
  }
  private handlePriorGridReadingChanged(e: any) {
    this.props.priorGridReadingChanged(e);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/singlerate/ElectricityFromGrid.tsx